/* ============================================================
   HERB & HEAL - CONTINUOUS TESTIMONIAL MARQUEE

   Turns the homepage "What Our Community Says" grid into the same
   continuously moving rail as "Join Our Happy Customers" on the
   product page.

   Why JavaScript: a CSS-only marquee with three cards leaves a
   visible gap every loop. The track has to be duplicated so the
   second copy is entering as the first leaves. CSS cannot clone
   nodes, so this does the cloning and hands the animation back to
   CSS.

   The section is found by its HEADING TEXT, not by a class name,
   because these hand-coded sections wrap everything in unnamed
   divs. That also means it keeps working if the markup is
   restyled, and quietly does nothing if the section is removed.
   ============================================================ */
(function () {
  'use strict';

  var HEADINGS = [/community says/i, /happy customers/i];

  function injectStyles() {
    if (document.getElementById('hh-marquee-style')) return;
    var css = [
      '.hh-marquee{overflow:hidden;width:100%;position:relative;',
      '-webkit-mask-image:linear-gradient(90deg,transparent 0,#000 5%,#000 95%,transparent 100%);',
      'mask-image:linear-gradient(90deg,transparent 0,#000 5%,#000 95%,transparent 100%);}',
      '.hh-marquee__track{display:flex!important;grid-template-columns:none!important;',
      'width:max-content!important;max-width:none!important;gap:var(--hh-s3,24px);',
      'animation:hh-marquee-scroll var(--hh-marquee-speed,48s) linear infinite;will-change:transform;}',
      '.hh-marquee__track>*{flex:0 0 var(--hh-marquee-card,360px);min-width:0;box-sizing:border-box;}',
      '.hh-marquee:hover .hh-marquee__track,',
      '.hh-marquee:focus-within .hh-marquee__track{animation-play-state:paused;}',
      '@keyframes hh-marquee-scroll{from{transform:translateX(0)}to{transform:translateX(-50%)}}',
      '@media (max-width:749px){.hh-marquee__track{--hh-marquee-card:280px}}',
      '@media (prefers-reduced-motion:reduce){.hh-marquee__track{animation:none!important;}',
      '.hh-marquee{overflow-x:auto;-webkit-overflow-scrolling:touch;}}'
    ].join('');
    var st = document.createElement('style');
    st.id = 'hh-marquee-style';
    st.textContent = css;
    document.head.appendChild(st);
  }

  function findTrack(section) {
    var divs = section.querySelectorAll('div');
    for (var i = 0; i < divs.length; i++) {
      var d = divs[i];
      if (d.children.length < 3) continue;
      var disp = getComputedStyle(d).display;
      if (disp === 'grid' || disp === 'flex') return d;
    }
    return null;
  }

  function build() {
    injectStyles();

    var sections = document.querySelectorAll('.shopify-section');

    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      var h = sec.querySelector('h2, h3');
      if (!h) continue;

      var match = false;
      for (var k = 0; k < HEADINGS.length; k++) {
        if (HEADINGS[k].test(h.textContent)) { match = true; break; }
      }
      if (!match) continue;

      // The product page rail already moves on its own.
      if (sec.querySelector('.hh-testi-track-wrap')) continue;

      var track = findTrack(sec);
      if (!track || track.dataset.hhMarquee) continue;

      track.dataset.hhMarquee = '1';
      track.classList.add('hh-marquee__track');

      var wrap = document.createElement('div');
      wrap.className = 'hh-marquee';
      track.parentNode.insertBefore(wrap, track);
      wrap.appendChild(track);

      // Duplicate the cards so the loop has no gap. The clones are
      // hidden from assistive tech - they are the same quotes.
      var originals = Array.prototype.slice.call(track.children);
      for (var j = 0; j < originals.length; j++) {
        var clone = originals[j].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      // Longer rails should not scroll faster just because there is
      // more of them - keep the perceived speed constant.
      track.style.setProperty('--hh-marquee-speed', (originals.length * 9) + 's');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build, { once: true });
  } else {
    build();
  }
})();
